import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connectTransfers as endpoints } from '../api_urls'
import { client } from '../utils'
import { TransferTable } from './TransferTable'

const App = props => {
  let [transfers, updateTransfers] = useState([])
  let [startingAfter, updateStartingAfter] = useState(null)
  let [endingBefore, updateEndingBefore] = useState(null)
  let [hasMoreTransfers, updateHasMoreTransfers] = useState(false)

  useEffect(() => {
    client
      .post(endpoints.getRecentTransfers(), { account_id: props.accountID })
      .then(resp => {
        updateTransfers(resp.data.data)
        if (resp.data.has_more) {
          updateHasMoreTransfers(true)
          updateStartingAfter(resp.data.starting_after)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  return (
    <React.Fragment>
      <TransferTable
        transfers={transfers}
        updateTransfers={updateTransfers}
        startingAfter={startingAfter}
        updateStartingAfter={updateStartingAfter}
        endingBefore={endingBefore}
        updateEndingBefore={updateEndingBefore}
        hasMoreTransfers={hasMoreTransfers}
        updateHasMoreTransfers={updateHasMoreTransfers}
      />
    </React.Fragment>
  )
}

export default App

App.propTypes = {
  accountID: PropTypes.string.isRequired,
}
